import { render, staticRenderFns } from "./VoteHistoryView.vue?vue&type=template&id=7071c75e&scoped=true"
import script from "./VoteHistoryView.vue?vue&type=script&lang=js"
export * from "./VoteHistoryView.vue?vue&type=script&lang=js"
import style0 from "./VoteHistoryView.vue?vue&type=style&index=0&id=7071c75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071c75e",
  null
  
)

export default component.exports